<template>
  <div class="col-md-12" style="">
    <h4 style="margin-top: 5px">
      Inquiry Details
      <b-button class="float-right" @click="handleback" variant="danger">
        <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
      </b-button>
    </h4>
    <hr />
    <div class="row">
      <div class="col-12" style="margin-top: 0px">
        <b-card-text>
          <div class="row" style="margin: 10px">
            <div class="col-12">
              <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <div block v-b-toggle.accordion-2 variant="info">
                      <div class="row" style="margin: 5px">
                        <div class="col-4">
                          <img src="../assets/123.jpg" height="50px" />
                        </div>
                        <div class="col-8">
                          <div class="row">
                            <div
                              class="col-6"
                              style="font-size: 18px; font-weight: bold"
                            >
                              Tag No
                            </div>
                            <div class="col-6" style="font-size: 18px">22</div>
                            <div
                              class="col-6"
                              style="font-size: 18px; font-weight: bold"
                            >
                              Type
                            </div>
                            <div class="col-6" style="font-size: 18px">Cow</div>
                            <div
                              class="col-6"
                              style="font-size: 18px; font-weight: bold"
                            >
                              Sender
                            </div>
                            <div class="col-6" style="font-size: 18px">
                              S.V. Patil
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div class="row" style="margin: 10px">
                        <div class="col-12">
                          <h5>Discussion</h5>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-2"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                          <div class="row">
                              <div class="col-12">
                                  <span class="float-right" style="margin:15px;">
                                       <img src="https://joeschmoe.io/api/v1/2" style="height:40px;width:40px">
                                  </span> &nbsp;
                                  <div class="float-right" style="border:1px solid #f9d2bb; border-radius:50px;width:70%;height:50px;background-color:#f9d2bb;padding:15px">
                                      <p>Deshi</p>
                                  </div>
                              </div><br/>
                               <div class="col-12">
                                   <span class="float-left" style="margin:15px;">
                                       <img src="https://joeschmoe.io/api/v1/random" style="height:40px;width:40px">
                                       </span> &nbsp;
                                   <div class="float-left" style="border:1px solid #bbf9bb;border-radius:50px;width:70%;height:50px;background-color:#bbf9bb;padding:15px">
                                       <p>What is prize ?</p>
                                   </div>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-12">
                                  <span class="float-right" style="margin:15px;">
                                       <img src="https://joeschmoe.io/api/v1/2" style="height:40px;width:40px">
                                  </span> &nbsp;
                                  <div class="float-right" style="border:1px solid #f9d2bb; border-radius:50px;width:70%;height:50px;background-color:#f9d2bb;padding:15px">
                                      <p>Deshi</p>
                                  </div>
                              </div><br/>
                               <div class="col-12">
                                   <span class="float-left" style="margin:15px;">
                                       <img src="https://joeschmoe.io/api/v1/random" style="height:40px;width:40px">
                                       </span> &nbsp;
                                   <div class="float-left" style="border:1px solid #bbf9bb;border-radius:50px;width:70%;height:50px;background-color:#bbf9bb;padding:15px">
                                       <p>What is prize ?</p>
                                   </div>
                              </div>
                          </div>
                          <hr/>
                        <div class="form-group row">
                          <div class="col-12">
                            <b-input-group>
                              <template #append>
                                <b-input-group-text @click="handleSearch">
                                  <b-icon-chat-text></b-icon-chat-text>
                                </b-input-group-text>
                              </template>
                              <b-form-input v-model="chat"></b-form-input>
                            </b-input-group>
                          </div>
                        </div>
                          <b-button block variant="primary">Close Sell Inquiry</b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                  
                </b-card>
              </div>
                 <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <div block v-b-toggle.accordion-1 variant="info">
                      <div class="row" style="margin: 5px">
                        <div class="col-4">
                          <img src="../assets/123.jpg" height="50px" />
                        </div>
                        <div class="col-8">
                          <div class="row">
                            <div
                              class="col-6"
                              style="font-size: 18px; font-weight: bold"
                            >
                              Tag No
                            </div>
                            <div class="col-6" style="font-size: 18px">23</div>
                            <div
                              class="col-6"
                              style="font-size: 18px; font-weight: bold"
                            >
                              Type
                            </div>
                            <div class="col-6" style="font-size: 18px">Cow</div>
                            <div
                              class="col-6"
                              style="font-size: 18px; font-weight: bold"
                            >
                              Sender
                            </div>
                            <div class="col-6" style="font-size: 18px">
                              S.V. Patil
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div class="row" style="margin: 10px">
                        <div class="col-12">
                          <h5>Discussion</h5>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-1"
                    
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                          <div class="row">
                              <div class="col-12">
                                  <span class="float-right" style="margin:15px;">
                                       <img src="https://joeschmoe.io/api/v1/2" style="height:40px;width:40px">
                                  </span> &nbsp;
                                  <div class="float-right" style="border:1px solid #f9d2bb; border-radius:50px;width:70%;height:50px;background-color:#f9d2bb;padding:15px">
                                      <p>Deshi</p>
                                  </div>
                              </div><br/>
                               <div class="col-12">
                                   <span class="float-left" style="margin:15px;">
                                       <img src="https://joeschmoe.io/api/v1/random" style="height:40px;width:40px">
                                       </span> &nbsp;
                                   <div class="float-left" style="border:1px solid #bbf9bb;border-radius:50px;width:70%;height:50px;background-color:#bbf9bb;padding:15px">
                                       <p>What is prize ?</p>
                                   </div>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-12">
                                  <span class="float-right" style="margin:15px;">
                                       <img src="https://joeschmoe.io/api/v1/2" style="height:40px;width:40px">
                                  </span> &nbsp;
                                  <div class="float-right" style="border:1px solid #f9d2bb; border-radius:50px;width:70%;height:50px;background-color:#f9d2bb;padding:15px">
                                      <p>Deshi</p>
                                  </div>
                              </div><br/>
                               <div class="col-12">
                                   <span class="float-left" style="margin:15px;">
                                       <img src="https://joeschmoe.io/api/v1/random" style="height:40px;width:40px">
                                       </span> &nbsp;
                                   <div class="float-left" style="border:1px solid #bbf9bb;border-radius:50px;width:70%;height:50px;background-color:#bbf9bb;padding:15px">
                                       <p>What is prize ?</p>
                                   </div>
                              </div>
                          </div>
                          <hr/>
                        <div class="form-group row">
                          <div class="col-12">
                            <b-input-group>
                              <template #append>
                                <b-input-group-text @click="handleSearch">
                                  <b-icon-chat-text></b-icon-chat-text>
                                </b-input-group-text>
                              </template>
                              <b-form-input v-model="chat"></b-form-input>
                            </b-input-group>
                          </div>
                        </div>
                          <b-button block variant="primary">Close Sell Inquiry</b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                  
                </b-card>
              </div>
            </div>
          </div>
        
        </b-card-text>
      </div>
    </div>
    <br />
  </div>
</template>
<script>
export default {
  data() {
    return {
      chat: "",
      tabIndex: 0,
    };
  },
  methods: {
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    handleback() {
      this.$router.go(-1);
    },
    add_to_cart() {
      alert("Added To Cart");
    },
    send_enquiry() {
      alert("Enquiry send to buyer");
    },
  },
};
</script>
